/* eslint-disable no-underscore-dangle */
let contentfulKey
let contentfulSpace
let saltUrl
let merchantId
let paymentTokenValue
let isLocalTesting
let siteKey
let enableRecaptchaConsumer
let enableRecaptchaDealer
let processEnv

if (Object.keys(process.env).length === 0 || process.env.BROWSER) {
  contentfulKey = window.__SERVER_DATA_.KPREAP_CONTENTFUL_KEY || ''
  contentfulSpace = window?.__SERVER_DATA_?.KPREAP_CONTENTFUL_SPACE || ''
  saltUrl = window?.__SERVER_DATA_?.KPREAP_SALT_URL || ''
  merchantId = window?.__SERVER_DATA_?.KPREAP_SALT_MERCHANT || ''
  paymentTokenValue = window?.__SERVER_DATA_?.KPREAP_SALT_TOKEN || ''
  isLocalTesting = window?.__SERVER_DATA_?.LOCAL_TESTING || ''
  siteKey = window?.__SERVER_DATA_?.RECAPTCHA_SITE_KEY || ''
  enableRecaptchaConsumer = window?.__SERVER_DATA_?.ENABLE_RECAPTCHA_CONSUMER || ''
  enableRecaptchaDealer = window?.__SERVER_DATA_?.ENABLE_RECAPTCHA_DEALER || ''
  processEnv = window?.__SERVER_DATA_?.APP_ENV || ''
} else {
  // This will only happen on the server side
  contentfulKey = process.env.KPREAP_CONTENTFUL_KEY || ''
  contentfulSpace = process?.env?.KPREAP_CONTENTFUL_SPACE || ''
  saltUrl = process?.env?.KPREAP_SALT_URL || ''
  merchantId = process?.env?.KPREAP_SALT_MERCHANT || ''
  paymentTokenValue = process?.env?.KPREAP_SALT_TOKEN || ''
  isLocalTesting = process?.env?.LOCAL_TESTING || ''
  siteKey = process?.env?.RECAPTCHA_SITE_KEY || ''
  enableRecaptchaConsumer = process?.env?.ENABLE_RECAPTCHA_CONSUMER || ''
  enableRecaptchaDealer = process?.env?.ENABLE_RECAPTCHA_DEALER || ''
  processEnv = process?.env?.APP_ENV || ''
}

const planMfeBffBaseUrl = 'https://preview.www.koodomobile.com/prepaid/mfe'
const planMfeRemoteUrl =
  'https://assets.preview.www.koodomobile.com/1277136507/prepaid-digital-plan-mfe/v1/mf2/remoteEntry.js'

const contentful = {
  accessToken: contentfulKey,
  spaceId: contentfulSpace,
  environmentId: 'digital2b'
}

const googleReCaptchaConfig = {
  siteUrl: 'https://www.google.com/recaptcha/api/siteverify',
  siteKey,
  enableRecaptchaConsumer,
  enableRecaptchaDealer
}

let backendUrl =
  'https://publicmobile-public-mobile-mvne-web-previewmvne.np.gke.telus.digital'

const locale = {
  cookieDomain: '.telus.digital'
}

if (isLocalTesting === 'ON') {
  // Use the current origin in the browser so any local host
  // (local.publicmobile.ca, local.koodomobile.com) calls itself
  // instead of a hardcoded cross-origin URL blocked by CORS.
  if (typeof window !== 'undefined') {
    backendUrl = window.location.origin
    locale.cookieDomain = `.${window.location.hostname.replace(/^local\./, '')}`
  } else {
    backendUrl = 'http://local.publicmobile.ca:3000'
    locale.cookieDomain = '.publicmobile.ca'
  }
}

const partnerCookieId = 'partnerCache'

const cookieSecure = true

const tagManager =
  '//assets.adobedtm.com/a2962fe01e14/ec556f4805a8/launch-d3ffc97e9ec8-staging.min.js'

const paymentConfig = {
  registrationUrl: saltUrl,
  merchantId
}

const paymentToken = paymentTokenValue

export default {
  contentful,
  backendUrl,
  partnerCookieId,
  tagManager,
  paymentConfig,
  paymentToken,
  cookieSecure,
  googleReCaptchaConfig,
  locale,
  planMfeBffBaseUrl,
  planMfeRemoteUrl,
  processEnv
}
